import { createFileRoute } from '@tanstack/react-router';
import { SendMoneyCalculatorPage } from '~/components/sections/SendMoneyCalculatorPage';
import { sendMoneyHero } from '~/content/sendMoneyHome';
import { pageHeadMeta } from '~/lib/seo';
import calculatorStylesHref from '~/styles/calculator.css?url';

export const Route = createFileRoute('/send-money-home')({
  head: () =>
    pageHeadMeta({
      title: 'Send money home at the best rates — nsave',
      description:
        "Convert and send money internationally for just $1 with nsave's currency calculator. Get the best exchange rates for USD to BDT, EGP, PKR, TRY, and more.",
      path: '/send-money-home',
      stylesheets: [calculatorStylesHref],
    }),
  component: SendMoneyHomePage,
});

function SendMoneyHomePage() {
  return <SendMoneyCalculatorPage heroTitle={sendMoneyHero.title} initialTarget="EGP" />;
}
